import { useState } from 'react'
import Button from '@dd3tech/wiggui/Button'
import Dropdown from '@dd3tech/wiggui/Dropdown'
import Flex from '@dd3tech/wiggui/Flex'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Input from '@dd3tech/wiggui/Input'
import Spinner from '@dd3tech/wiggui/Spinnner'
import Text from '@dd3tech/wiggui/Text'
import type { IContactData } from '../../../../interfaces'
import { composeClasses } from '@wiggot/utils'

interface DropdownContactProps {
  isLoading: boolean
  isNewCustomer: boolean
  resultSearch: IContactData[]
  searchValueCustomer: string
  debounceSearchValueCustomer: string
  handleSelectContact: (contact: IContactData) => void
  dataCustomer: {
    name: string
    phone: string
    phoneCode: string
    email: string
  }
  handleNewCustomer: () => void
  selectedCustomer: IContactData | null
  handleResetContact: () => void
  setSearchValueCustomer: (value: string) => void
  formIsDisabled: boolean
  newDesign?: boolean
}

export const DropdownContact = ({
  isLoading,
  isNewCustomer,
  resultSearch,
  handleSelectContact,
  dataCustomer,
  selectedCustomer,
  handleResetContact,
  setSearchValueCustomer,
  searchValueCustomer,
  handleNewCustomer,
  debounceSearchValueCustomer,
  formIsDisabled,
  newDesign = false
}: DropdownContactProps) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Flex className="w-full h-full">
      <Dropdown
        className="w-full"
        isResponsive={false}
        closeOnEscape={false}
        closeOnOutsideClick={false}
        onClose={() => setIsOpen(false)}
        setIsOpen={setIsOpen}
        isOpen={isOpen && searchValueCustomer?.length > 0 && !formIsDisabled}
      >
        <Dropdown.Trigger className="w-full">
          <>
            {!isNewCustomer && (
              <Input
                name="name"
                disabled={formIsDisabled}
                value={selectedCustomer?.name ?? searchValueCustomer}
                onChange={(event) =>
                  setSearchValueCustomer(event?.target.value)
                }
                className="w-full"
                classNameInput="w-full"
                classNameContainer="w-full"
                classNameLabel="text-secondary"
                labelText="Escribe un nombre"
                leftIcon={
                  <GoogleIcon
                    name="search"
                    className="text-primary text-[24px]"
                  />
                }
                rightIcon={
                  selectedCustomer?.name && (
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation()
                        handleResetContact()
                      }}
                    >
                      <GoogleIcon name="close" className="text-primary" />
                    </button>
                  )
                }
              />
            )}
          </>
        </Dropdown.Trigger>
        <Dropdown.Menu className="!pb-0 !pt-4 !py-0">
          <>
            {searchValueCustomer.length > 0 && (
              <Flex
                className={composeClasses(
                  'bg-white ui-kit-scrollbar overflow-y-auto max-h-[30vh] rounded-xl w-full  h-full top-16 left-0 right-0',
                  newDesign ? 'w-full' : 'md:max-w-[462px]'
                )}
                dir="col"
                wFull
                gap="gap-3"
                items="start"
                justify="start"
              >
                {!isNewCustomer && isLoading && (
                  <Flex items="center" justify="center" wFull className="py-2">
                    <Spinner color="terciary" />
                  </Flex>
                )}
                {!isNewCustomer &&
                  resultSearch?.length > 0 &&
                  resultSearch?.map((contact) => {
                    return (
                      <Flex
                        as="button"
                        dir="col"
                        gap="gap-1"
                        items="start"
                        wFull
                        justify="start"
                        key={contact?.contactId + contact?.name}
                        onClick={(event) => {
                          event.stopPropagation()
                          handleSelectContact(contact)
                        }}
                        className={composeClasses(
                          dataCustomer?.name === contact?.name && 'font-bold',
                          'text-left px-4 hover:font-bold'
                        )}
                      >
                        <Text
                          className={composeClasses(
                            'truncate',
                            newDesign ? 'w-full' : 'max-w-[200px]'
                          )}
                        >
                          {contact?.name ?? ''}
                        </Text>
                        {!newDesign && (
                          <Text className="truncate max-w-[200px]">
                            {contact?.mainEmail ?? ''}
                          </Text>
                        )}
                      </Flex>
                    )
                  })}
                {!isLoading &&
                  !isNewCustomer &&
                  debounceSearchValueCustomer?.length > 0 &&
                  resultSearch?.length === 0 && (
                    <Text
                      align="center"
                      className="text-body-bold-m w-full text-primary !rounded-sm"
                    >
                      No se encontraron resultados
                    </Text>
                  )}
                {!isLoading && !isNewCustomer && !newDesign && (
                  <Button
                    variant="secondary"
                    fullWidth
                    onClick={(event) => {
                      event.stopPropagation()
                      handleNewCustomer()
                    }}
                    size="small"
                    rightIcon={<GoogleIcon name="add" className="text-white" />}
                    className="text-body-bold-m text-primary !rounded-sm"
                  >
                    Nuevo cliente
                  </Button>
                )}
              </Flex>
            )}
          </>
        </Dropdown.Menu>
      </Dropdown>
    </Flex>
  )
}
